/** Column catalog entry for list Configure modal + localStorage prefs. */
export type ListColumnCatalogItem = {
  id: string;
  label: string;
  /** When true, column starts hidden until the user enables it (optional fields). */
  optional?: boolean;
};

const STORAGE_PREFIX = 'ggj:list_cols:';

function defaultVisibility(catalog: ListColumnCatalogItem[]): Record<string, boolean> {
  const out: Record<string, boolean> = {};
  for (const c of catalog) {
    out[c.id] = c.optional ? false : true;
  }
  return out;
}

/** Read merged visibility for org; falls back to defaults when missing or invalid. */
export function readListColumnPrefs(
  entityKey: string,
  orgId: string | null,
  catalog: ListColumnCatalogItem[],
): Record<string, boolean> {
  const defaults = defaultVisibility(catalog);
  if (!orgId) return { ...defaults };
  try {
    const raw = localStorage.getItem(`${STORAGE_PREFIX}${entityKey}:${orgId}`);
    if (!raw) return { ...defaults };
    const parsed = JSON.parse(raw) as Record<string, unknown>;
    const merged = { ...defaults };
    for (const c of catalog) {
      if (typeof parsed[c.id] === 'boolean') merged[c.id] = parsed[c.id] as boolean;
    }
    return merged;
  } catch {
    return { ...defaults };
  }
}

export function writeListColumnPrefs(
  entityKey: string,
  orgId: string,
  visibility: Record<string, boolean>,
): void {
  try {
    localStorage.setItem(`${STORAGE_PREFIX}${entityKey}:${orgId}`, JSON.stringify(visibility));
  } catch {
    /* ignore quota / private mode */
  }
}
